import { useEffect, memo } from "react";
import { Outlet } from "react-router-dom";
import { readHomePageService } from "services/globalService";
import { STATE_ENTITIES } from "utils/entities";
import { createApiThunk } from "store/thunks/apiThunks";
import { createResetEntityApi } from "store/features/apiSlice";




import { useSelector, useDispatch } from "react-redux";

import { MatxSuspense } from "components";


const SessionGuard = () => {
  const dispatch = useDispatch()

  const fetchHomepage = async () => {
    try {
      const dynamicThunk = createApiThunk(STATE_ENTITIES.GLOBAL.HOMEPAGE, readHomePageService, { page_name: "session" });
      dispatch(dynamicThunk({ entity: STATE_ENTITIES.GLOBAL.HOMEPAGE }));
    } catch (error) {
    }
  };











  useEffect(() => {
    // Fetch data on component mount
    fetchHomepage();
    // Clean up on component unmount
    return () => {
      dispatch(createResetEntityApi(STATE_ENTITIES.GLOBAL.HOMEPAGE));
    };
  }, []);




  return (
    <MatxSuspense>
    <Outlet />
  </MatxSuspense>

  );
};

export default memo(SessionGuard);
